import { render, staticRenderFns } from "./scoreShenPi.vue?vue&type=template&id=0c6ca288&scoped=true"
import script from "./scoreShenPi.vue?vue&type=script&lang=js"
export * from "./scoreShenPi.vue?vue&type=script&lang=js"
import style0 from "./scoreShenPi.vue?vue&type=style&index=0&id=0c6ca288&prod&lang=css"
import style1 from "./scoreShenPi.vue?vue&type=style&index=1&id=0c6ca288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ca288",
  null
  
)

export default component.exports